import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "asMessageForm_placeholder" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "asMessageForm_files"
}
const _hoisted_3 = { class: "asMessageForm_progress" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "asMessageForm_name" }
const _hoisted_6 = { class: "asMessageForm_fileupload" }
const _hoisted_7 = { class: "asMessageForm_col -field" }
const _hoisted_8 = {
  class: "asMessageForm_fieldWrap",
  ref: "refTextareaWrap"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["placeholder", "autofocus"]
const _hoisted_11 = {
  key: 0,
  class: "asMessageForm_limit"
}
const _hoisted_12 = { class: "asMessageForm_error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["asMessageForm", { '-fixed': _ctx.fixed }])
  }, [
    _hoisted_1,
    (_ctx.files)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, id) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "asMessageForm_file",
              key: id
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "asMessageForm_fill",
                  style: _normalizeStyle({ width: `${file.percent}%` })
                }, null, 4)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["asMessageForm_status", { [`-${file.status}`]: file.status }])
              }, null, 2),
              _createElementVNode("div", {
                class: "asMessageForm_remove",
                onClick: ($event: any) => (_ctx.remove(id))
              }, null, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, _toDisplayString(file.name), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: "asMessageForm_input",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["stop","prevent"]))
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("input", {
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fileUploadWeb && _ctx.fileUploadWeb(...args))),
          type: "file"
        }, null, 32)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("span", {
            class: "asMessageForm_hiddenText",
            innerHTML: _ctx.msg(_ctx.message)
          }, null, 8, _hoisted_9), [
            [_vShow, !_ctx.autoResize]
          ]),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass(["asMessageForm_field", {
              '-error': _ctx.error,
              '-autoResize': _ctx.autoResize,
            }]),
            placeholder: _ctx.$t('input.message'),
            ref: "refTextarea",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.messageModel) = $event)),
            autofocus: _ctx.autofocus,
            "data-cy": "asMessageForm_textarea",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handlerFocusTextarea && _ctx.handlerFocusTextarea(...args)))
          }, null, 10, _hoisted_10), [
            [
              _vModelText,
              _ctx.messageModel,
              void 0,
              { trim: true }
            ]
          ])
        ], 512),
        (_ctx.message.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.message.length) + "/" + _toDisplayString(_ctx.messageMaxLength), 1))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.error), 1)
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["asMessageForm_send", { '-sending': _ctx.sending }]),
        "data-cy": "asMessageForm_send",
        type: "submit"
      }, null, 2)
    ], 32)
  ], 2))
}